import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const NumbersNoMobileDecorator = () => (
  <>
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-butterscotch absolute -left-10 top-[calc(50%-70px)] hidden h-8 w-8 rotate-[-90deg] md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute -left-2 top-[calc(50%-30px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute -right-4 hidden h-6 w-6 md:top-[calc(50%+40px)] md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute -right-10 top-[calc(50%-30px)] hidden h-6 w-6 md:block"
    />
  </>
);
